export const GET_SESSION_CATEGORYS = "GET_SESSION_CATEGORYS";
export const GET_SESSION_CATEGORY_BY_ID = "GET_SESSION_CATEGORY_BY_ID";
export const UPDATE_SESSION_CATEGORY = "UPDATE_SESSION_CATEGORY";
export const DELETE_SESSION_CATEGORY = "DELETE_SESSION_CATEGORY";
export const CREATE_SESSION_CATEGORY = "CREATE_SESSION_CATEGORY";
